/* ============================================================
   KATY COUTURE — katy-theme.js
   Drawer | Search | Theme toggle
   AUCUN document.body.style.overflow = hidden ici
   ============================================================ */

function toggleTheme() {
  var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  localStorage.setItem('katy-theme', next);
}

function openDrawer() {
  document.getElementById('drawer').classList.add('active');
  document.getElementById('drawer-overlay').classList.add('active');
}

function closeDrawer() {
  document.getElementById('drawer').classList.remove('active');
  document.getElementById('drawer-overlay').classList.remove('active');
}

function toggleSearch() {
  var overlay = document.getElementById('search-overlay');
  if (overlay) overlay.classList.toggle('active');
}